import { tgxApi } from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess,
} from "../../../helpers/utils/RtkQueryUtils";
import { getFileName, serialize } from "../../../helpers/utils/Utils";
import { downloadFile } from "../../../helpers/utils/FileUtils";
import UpdateAutoHoa from "./templates/UpdateAutoHoa";

export const autoHoaApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchAutoHoaApi: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/ajax/auto-hoa?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['autoHoa'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
  
        getAutoHoaById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-auto-hoa-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['autoHoaById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportAutoHoaData: build.query({
            query: (query) => {
                return {
                    url: `/export/auto-hoa?`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("auto_hoa"))
                        return { success: true };
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createAutoHoa: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create/auto-hoa`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['autoHoa','customers'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Auto HOA")
            },
        }),
        UpdateAutoHoa: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/ajax/update/auto-hoa/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['autoHoa', 'autoHoaById', 'userAuditableInfo','customers'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Auto HOA")
            },
        }),

        deleteAutoHoaById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete/auto-hoa/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['autoHoa','customers'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Auto HOA");
            },
        }),
    })
});


export const {
    useGetAutoHoaByIdQuery,
    useSearchAutoHoaApiQuery,
    useLazyExportAutoHoaDataQuery,
    useCreateAutoHoaMutation,
    useUpdateAutoHoaMutation,
    useDeleteAutoHoaByIdMutation
} = autoHoaApi;